const collectionsToManuallyInsert = [
  {
    placeBeforeColId: '100631001',
    id: '100800001',
    title: 'Sound Dampening',
    imageUrl: '/image/collections/sound-deadening/Sound-Deadening_400px.webp',
    slug: '/products/SK2MM-car-sound-deadening?sku=SK2MM-BULKKIT'
  }
];

export const insertMenuItemsBeforeId = (menuLinks) => {
  const newItems = [...collectionsToManuallyInsert];
  let newMenuLinks = [...menuLinks]; // Create a new array
  newItems.forEach((newItem) => {
    const targetId = newItem?.placeBeforeColId;
    const index = newMenuLinks.findIndex((item) => item.id === targetId);

    if (index !== -1) {
      newMenuLinks.splice(index, 0, newItem);
    }
  });

  return newMenuLinks;
};
